module.exports = __webpack_public_path__ + "img/wtb3.7366ee53.png";